import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChrome, faEdge, faSafari, faOpera } from '@fortawesome/free-brands-svg-icons';
import { MibButtonComponent, MibIconsModule } from '@medinbox/angular';

@Component({
  selector: 'app-browser-not-supported',
  imports: [FontAwesomeModule, MibButtonComponent, MibIconsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './browser-not-supported.component.html',
})
export class BrowserNotSupportedComponent {
  faChrome = faChrome;
  faEdge = faEdge;
  faSafari = faSafari;
  faOpera = faOpera;

  displayCloseButton = !!window.opener;

  protected onClickTerminate(event: MouseEvent) {
    event.preventDefault();
    if (window && window.close) window.close();
  }
}
